import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HouseOutlinedNew: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 21, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.0386 20H3.59971C1.61267 20 0 18.3873 0 16.4003V8.29854C0 7.12743 0.575954 6.02352 1.53588 5.35157L8.25534 0.647948C9.49364 -0.215983 11.1543 -0.215983 12.383 0.647948L19.1025 5.35157C20.0624 6.02352 20.6383 7.12743 20.6383 8.29854V16.4003C20.6383 18.3873 19.0257 20 17.0386 20ZM10.3192 1.43508C9.88721 1.43508 9.45524 1.56947 9.08087 1.82865L2.36141 6.53228C1.78546 6.93544 1.43988 7.59779 1.43988 8.29854V16.4003C1.43988 17.5906 2.40941 18.5601 3.59971 18.5601H17.0386C18.2289 18.5601 19.1985 17.5906 19.1985 16.4003V8.29854C19.1985 7.59779 18.8529 6.93544 18.2769 6.53228L11.5575 1.82865C11.1831 1.56947 10.7511 1.44468 10.3192 1.44468V1.43508Z"
        fill="#1B3029"
      />
      <path
        d="M14.1591 20.0001H6.47971C6.08614 20.0001 5.75977 19.6737 5.75977 19.2801V14.4805C5.75977 11.9655 7.8044 9.9209 10.3194 9.9209C12.8344 9.9209 14.879 11.9655 14.879 14.4805V19.2801C14.879 19.6737 14.5527 20.0001 14.1591 20.0001ZM7.19965 18.5602H13.4392V14.4805C13.4392 12.7623 12.0377 11.3608 10.3194 11.3608C8.60114 11.3608 7.19965 12.7623 7.19965 14.4805V18.5602Z"
        fill="#1B3029"
      />
    </svg>
  )
})

HouseOutlinedNew.displayName = 'HouseOutlinedNew'
